import React ,{useState,useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import SelectOption from '../../common/SelectOption';
import AutoCompete from '../../common/AutoCompleteField';
import { Form, Input, Button,Row,Col, AutoComplete} from 'antd';
import {emptyValidation} from '../../../helper/FeildValidations';
import {getWeeklyPicks,deleteWeeklyPicks,filterSpaceName, setWeeklyPicks, updateWeeklyPick,deleteNewWeeklyPick,saveWeeklyPicks, clearFilterSpaceName} from '../Spaces/SpaceAction';
import toastr from 'toastr';
import {COUNTRY_CODES, SPACE_STATUS} from '../../common/constants'

const layout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };

const inputStyle = { marginBottom: "5px" }
const numberOfWeeklyPicks = 10;

const WeeklyPicks =() => {    
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [country, setCountry] = useState();
    const weeklyPicks = useSelector(state => state.space?.weeklyPicks?.data || null);
    const spaceNameFilter = useSelector(state => state.space?.filterSpaceName?.data || []);
    const [selectedSpace, setSelectedSpace] = useState([]);

    useEffect (() => {
      if(country){
        dispatch(getWeeklyPicks(country));
      }  
    },[country]);

    useEffect(() => {
      // Clear filter data when component mounts to ensure fresh data
      dispatch(clearFilterSpaceName());
    }, []);

    useEffect(() => {
      // Clear filter data when country changes to ensure fresh data for new country
      if(country) {
        dispatch(clearFilterSpaceName());
      }
    }, [country]);

    useEffect(() => {
      // Cleanup filter data when component unmounts
      return () => {
        dispatch(clearFilterSpaceName());
      };
    }, []);

    const handleCountrySelect =(country) => {
      // Clear previous filter data before setting new country
      dispatch(clearFilterSpaceName());
      setCountry(country);
    }

    const clearFields = () => {
      form.resetFields();
      setCountry(null);
      dispatch(clearFilterSpaceName());
    };

    const handleDelete =(id) =>{      
      if(selectedSpace.length >= 1 ){
        const spacetoDelte = selectedSpace.filter((space) => space.spaceId === id);
        if(spacetoDelte.length === 1){
          dispatch(deleteNewWeeklyPick(spacetoDelte[0].spaceId));
          setSelectedSpace(selectedSpace.filter((space) => space.spaceId !== id));
          toastr.success('Successfully deleted');
        }else{
          dispatch(deleteWeeklyPicks(country, id));
        }
      } else{
        dispatch(deleteWeeklyPicks(country, id));
      }         
      
    }

    const handleOnchange = (searchText) => {
      if(searchText && searchText.length > 3){
        dispatch(filterSpaceName(0, 20, searchText, country));
      }
    };

    const handleSpaceOnSelect = (value, option) => {
      const existingPick = weeklyPicks.filter(weeklyPick => weeklyPick.id === option.key);
      
      if(!Boolean(existingPick.length)){
        if(weeklyPicks.length >= numberOfWeeklyPicks){
          toastr.success('You have added maximum number of Weekly Picks!');
        }else{
          const space = spaceNameFilter.find(space => 
            space.id === option.key
        );

         // Check if space exists and is deactivated
        if(!space) {
          toastr.error('Space not found.');
          return;
        }

        if(space.spaceStatus !== SPACE_STATUS.ACTIVE) {
          toastr.error('Cannot add deactivated spaces.');
          return;
        }

        const chargingOptions = space.events?.[0].chargings
              .map((charging) => {
              return  {id :charging.chargingType.id, name :charging.chargingType.unit } });

        const events = space?.events?.map((event) => 
              { return {id : event.eventType.id, name : event.eventType.name } });

        setSelectedSpace([...selectedSpace, {spaceId :  option.key}]);
        dispatch(setWeeklyPicks({
          id: option.key,
          name: option.value,
          charginOptions : chargingOptions,
          events: events
        }));
        }

          
      }
    }

    const handleEventTypeSelect = (spaceId, selectedValue) => {
      setSelectedSpace(selectedSpace.map((space) => ( space.spaceId  === spaceId ? {...space, eventType : selectedValue} : space)))
      dispatch(updateWeeklyPick({ id : spaceId, eventTypeId : selectedValue}));
    }

    const handleChargingTypeSelect = (spaceId, selectedValue) => {
      setSelectedSpace(selectedSpace.map((space) => ( space.spaceId  === spaceId ? {...space, chargingType : selectedValue} : space)));
      dispatch(updateWeeklyPick({ id : spaceId, chargingTypeId : selectedValue}));
    }
   
    const onFinish = () => {
      const payload = selectedSpace.map((space) => ({"spaceId":space.spaceId, "eventTypeId":space.eventType, "chargingTypeId":space.chargingType}))
      if(Boolean(payload.length)){
        dispatch(saveWeeklyPicks(country,payload,clearFields));
        setSelectedSpace([]);
      }    
    }

    return(
        <>
  
        <Form
          {...layout}
          form={form}
          onFinish={onFinish}
        >
          <h1 className="title">Picks of the Week</h1>
          <div className="weekly-picks-wrap">
            <SelectOption
              isMultiple={false}
              name={['spaceOwner', 'country']}
              placeholder={'Country Code'}
              rules={emptyValidation}
              label={'Country Code'}
              values={COUNTRY_CODES}
              handleOnSelect={handleCountrySelect }
              labelName={'label'}
              valueName={'name'}
            />
            {country && 
            <>
              <AutoCompete
                key={country} // Force re-render when country changes
                label={'Space Name'}
                rules={emptyValidation}
                options={spaceNameFilter.filter(space => space.spaceStatus === SPACE_STATUS.ACTIVE)}
                handleOnChange={handleOnchange}
                handleOnSelect={handleSpaceOnSelect}
                labelName={'spaceName'}
                valueName={'spaceName'}
                placeholder={'Space Name'}                
              />  
              <Form.Item label="Space Details" >
                {weeklyPicks && weeklyPicks.map((pick,index) => 
                  <Row gutter={8} key={pick.id}>
                  <Col span={10}>
                    <Input
                        name={'Space'} 
                        rules={emptyValidation}
                        placeholder={'Space'}
                        value={pick.name}
                        style={inputStyle}
                        disabled={true}
                      />
                  </Col>
                  <Col span={7}>
                  {pick?.events?.length ? 
                    <SelectOption
                      isMultiple={false}
                      placeholder={'Event Type'}
                      rules={emptyValidation}
                      values={pick.events}
                      handleOnSelect={value => handleEventTypeSelect(pick.id, value)}
                      labelName={'name'}
                      valueName={'id'}
                      value={pick.eventTypeId}
                      style={inputStyle}
                    /> :
                    <Input
                      name={'Activity'} 
                      placeholder={'Activity'}
                      value={pick.eventType}
                      style={inputStyle}
                      rules={emptyValidation}
                      disabled={true}
                    />}
                  </Col>
                  <Col span={4}>
                  {pick?.charginOptions?.length ?  
                    <SelectOption
                      isMultiple={false}
                      placeholder={'Charging Types'}
                      rules={emptyValidation}
                      values={pick.charginOptions}
                      handleOnSelect={value => handleChargingTypeSelect(pick.id, value)}
                      labelName={'name'}
                      valueName={'id'}
                      value={pick.chargingTypeId}
                      style={inputStyle}
                    /> :
                    <Input
                      name={'PricingOption'} 
                      placeholder={'Charging Types'}
                      value={pick.rateUnit}
                      style={inputStyle}
                      rules={emptyValidation}
                      disabled={true}
                    /> }
                  </Col>
                  <Col span={3}>
                  <div className="btn-blue" style={inputStyle} type="primary" onClick={() => handleDelete(pick.id)}>Delete</div>
                  {/* <Button className="submit-btn" type="primary" style={inputStyle} htmlType="submit" onClick={() => handleDelete(pick.id)}>Delete</Button>  */}
                  </Col>
                  </Row>
                )}
              </Form.Item>              
              <div className="btn-wrapper">              
                <Button className="submit-btn" type="primary" htmlType="submit" >
                  Save
                </Button>
              </div>
            </>}           
          </div>
        </Form>
        </>
    );
};

export default WeeklyPicks;